import Pagination from '../Pagination'
import Sort from '../SortReq'

// Old-server backup browser (BACKUP_RESTORE). One request shape for every
// /backup/<entity>/get/all list — the backend ignores the keys an entity
// doesn't use (types/realTypes = monetary, states/symbol = trades,
// kinds/results/userIds = restore log).
const list = v => (Array.isArray(v) && v.length ? v : null)

export default function (other) {
  other = other || {}
  const range = other.range || {}
  return {
    search: (other.search || '').trim() || null,
    statuses: list(other.statuses),
    orgIds: list(other.orgIds),
    // Day strings (YYYY-MM-DD), both inclusive.
    range: { from: range.from || null, until: range.until || null },
    onlyWithMissingItems: other.onlyWithMissingItems === true ? true : null,
    clientBackupId: other.clientBackupId || null,
    // monetary
    types: list(other.types),
    realTypes: list(other.realTypes),
    // trades
    states: list(other.states),
    symbol: (other.symbol || '').trim() || null,
    // restore log
    kinds: list(other.kinds),
    results: list(other.results),
    userIds: list(other.userIds),
    pagination: other.pagination || Pagination(1, 25),
    sort: other.sort || Sort(),
  }
}
